import { render, staticRenderFns } from "./CloneSkuUpdateDialog.vue?vue&type=template&id=8bb3a8ea&"
import script from "./CloneSkuUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./CloneSkuUpdateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports